export function getAbsoluteURL(url: string = "") {
    if (url?.startsWith("http://") || url?.startsWith("https://")) {
        return url;
    } else {
        return process.env.REACT_APP_CMS_ENDPOINT + url;
    }
}

export const handleAppRedirect = () => {
    try {
        window.location.href = "digihappy://open";
    } catch (error) {
        console.error("App redirect failed:", error);
    }
};
